import styled from 'styled-components/macro';
import {
  FlexAlignCenter,
  FlexColumn,
  FlexJustifyBetween,
  FlexJustifyCenter,
  FlexNoAlign,
} from '../../../shared-styles/flex';
import { StandardBottomMargin, Link } from '../../../shared-styles';

const MainContainer = styled.main`
  width: 100%;
`;

export const LinkContainer = styled.div`
  ${FlexAlignCenter}
  width: fit-content;
  margin: ${(props) => props.theme.spacing(15)} ${(props) => props.theme.spacing(30)};
  ${Link}
`;

export const NavIcon = styled.img`
  transform: scaleX(-1);
  margin-right: ${(props) => props.theme.spacing(10)};
`;

export const HeaderBar = styled.div`
  width: 100%;
  height: 81px;
  background-color: ${(props) => props.theme.palette.custom.gray};
  padding: 0 ${(props) => props.theme.spacing(30)};
  ${FlexAlignCenter}
`;

export const HeaderDetailsContainer = styled.div`
  gap: 60px;
  ${FlexAlignCenter}
  margin-right: 60px;
`;

export const StyledLink = styled.a`
  ${Link}
  text-decoration: none;
`;

export const HeaderPill = styled.div`
  border-radius: 8px;
  margin-right: ${(props) => props.theme.spacing(10)};
  background-color: ${(props) => props.theme.palette.black[50]};
  border-color: ${(props) => props.theme.palette.black[50]};
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
  font-size: ${(props) => props.theme.spacing(12)};
  height: 25px;
  color: white;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 16px;
  padding-right: 16px;
  text-align: center;
  padding-top: 4px;
  padding-bottom: ${(props) => props.theme.spacing(5)};
  text-transform: uppercase;
  max-width: 180px;
`;

export const HeaderLink = styled.div`
  ${Link}
  margin-left: auto;
  text-decoration: none;
`;

export const ContentContainer = styled.div`
  ${FlexJustifyCenter}
  padding-bottom: ${(props) => props.theme.spacing(20)};
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 600px 600px 600px;
  padding: 40px 30px;
  grid-column-gap: ${(props) => props.theme.spacing(30)};
  overflow-x: auto;
`;

export const GridTitle = styled.div`
  font-size: 16px;
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  border-bottom: 0.5px solid ${(props) => props.theme.palette.black[50]};
  padding-bottom: ${(props) => props.theme.spacing(20)};
  margin-bottom: ${(props) => props.theme.spacing(10)};
`;

export const ColumnContainer = styled.div`
  gap: ${(props) => props.theme.spacing(20)};
  ${FlexColumn}
`;

export const ModalContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${(props) => props.theme.spacing(5)};
  padding: ${(props) => props.theme.spacing(5)} 0;
`;

export const Label = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.h3};
  font-weight: ${(props) => props.theme.typography.weight.regular};
`;

export const Value = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.h3};
  font-weight: ${(props) => props.theme.typography.weight.semiBold};
`;

export const LockContainer = styled.div`
  ${FlexNoAlign}
  padding: ${(props) => props.theme.spacing(20)};
`;

export const LockIcon = styled.img`
  margin-right: ${(props) => props.theme.spacing(10)};
  height: ${(props) => props.height};
  width: ${(props) => props.width};
`;

export const HeaderContent = styled.div`
  ${FlexJustifyBetween}
  ${(props) => (props.locked ? `background-color: ${props.theme.palette.gray[50]};` : '')}
`;

export const LockContent = styled.p`
  font-weight: ${(props) => props.theme.typography.weight.medium};
`;

export const LoadNotFoundContainer = styled.div`
  ${FlexJustifyCenter}
  ${FlexAlignCenter}
  flex-direction: column;
  width: 100%;
  margin-top: 260px;
`;

export const LoadNotFoundTitle = styled.p`
  ${StandardBottomMargin}
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
  font-size: ${({ theme }) => theme.typography.sizes.h2};
`;

export const LoadNotFoundMessage = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.h2};
  width: 700px;
  text-align: center;
`;

export const LoadNotFoundLink = styled.a`
  ${Link}
  font-size: ${({ theme }) => theme.typography.sizes.h2};
`;

export default MainContainer;
